import { EventStatus } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import type { CalendarEntityType } from '../../stores/calendar.store';

export const PROVIDER_COLUMN_GAP_NEW = 44;
export const PROVIDER_COLUMN_MIN_WIDTH = 184;
export const EVENT_CARD_GAP = 4;
export const EVENT_CARD_MIN_WIDTH = 68;
export const OVERLAPPING_EVENTS_BUTTON_WIDTH = 40;
export const OVERLAPPING_EVENTS_BUTTON_TOTAL_SPACE = OVERLAPPING_EVENTS_BUTTON_WIDTH + EVENT_CARD_GAP;
export const SCROLLABLE_BUTTON_WIDTH = 40;
export const COLUMN_HEADER_HEIGHT = 36;
export const MIN_DRAG_DISTANCE = 10;

// This is the width of the vertical hours lane where hours get displayed
export const HOURS_LANE_WIDTH = 76;

export const PROVIDER_LANE_WIDTH = 200;
export const CALENDAR_VIEW_RIGHT_SPACING = 56;

export const EVENT_CARD_COLOR_LINE_WIDTH = 4;

export const getMaxProviderCount = (maxWidth: number): number => {
  const availableWidth = maxWidth - CALENDAR_VIEW_RIGHT_SPACING - HOURS_LANE_WIDTH;
  return Math.floor(availableWidth / PROVIDER_LANE_WIDTH);
};

// at-least min 2 providers should be visible before we switch to small mode (177px is width of side menus)
export const SMALL_MODE_CALENDAR_VIEW_BREAKPOINT = PROVIDER_LANE_WIDTH * 2 + HOURS_LANE_WIDTH + 177;

export const NON_ATTENDED_APPT_STATUS = [EventStatus.NO_SHOW, EventStatus.CANCELED];

export const CALENDAR_COLUMN_DRAG_DROP = {
  getDroppableType: (entityType: CalendarEntityType) => `CALENDAR_COLUMN_ENTITY_${entityType}`,
  getDroppableId: (locationId: string, entityType: CalendarEntityType) =>
    `CALENDAR_COLUMN_ENTITY_${locationId}_${entityType}`,
  getDraggableId: (entityId: string) => `CALENDAR_COLUMN_ENTITY_${entityId}`,
};

export const DRAG_PENDO_EVENT_ENTRY_POINTS = {
  drag: 'drag',
  menu: 'column_menu',
} as const;

export type DragPendoEventEntryPoints =
  (typeof DRAG_PENDO_EVENT_ENTRY_POINTS)[keyof typeof DRAG_PENDO_EVENT_ENTRY_POINTS];
